import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux/types';
import { VideoWizardObjective } from '../types';
import VideoWizardObjectiveStep from '../VideoWizardObjectiveStep';
import { trackStepChange } from './actions';
import { VideoFlowAction, VideoFlowState } from './state/types';
import { VideoFlowStep } from './types';

export type UseObjectiveStepProps = {
  completedName?: string;
  state: VideoFlowState;
  stateDispatch: React.Dispatch<VideoFlowAction>;
};

export default function useObjectiveStep(props: UseObjectiveStepProps) {
  const { completedName = 'Objective', stateDispatch } = props;
  const dispatch = useDispatch<Dispatch>();

  const handleSelectObjective = useCallback(
    (objective: VideoWizardObjective) => {
      stateDispatch({
        type: 'objective-select',
        payload: { objective },
      });

      if (objective === 'SingleClip') {
        dispatch(
          trackStepChange(VideoFlowStep.OBJECTIVE, {
            type: 'videoTranscription',
            step: 'objective',
            objectiveSelection: 'SingleClip',
          }),
        );
      }
    },
    [dispatch, stateDispatch],
  );

  return {
    step: {
      completedName,
      component: (
        <VideoWizardObjectiveStep onSelectObjective={handleSelectObjective} />
      ),
      name: 'Objective',
      renderCancelButton: () => null,
      renderNextButton: () => null,
      stepId: VideoFlowStep.OBJECTIVE,
    },
  };
}
